import { defineStore } from 'pinia';
import fiscalCatalogsAPI from '@/api/fiscalCatalogs';

export const useFiscalCatalogsStore = defineStore('fiscalCatalogs', {
    state: () => ({
        payment_forms: [] as any[],
        payment_methods: [] as any[],
        cfdi_uses: [] as any[],
        fiscal_regiments: [] as any[],
        product_units: [] as any[],
        taxes: [] as any[],
    }),
    actions: {
        async searchPaymentForms(filters: any) {
            try {
                const response = await fiscalCatalogsAPI.searchPaymentForms(filters);
                this.payment_forms = response;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
        async searchPaymentMethods(filters: any) {
            try {
                const response = await fiscalCatalogsAPI.searchPaymentMethods(filters);
                this.payment_methods = response;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
        async searchCfdiUses(filters: any) {
            try {
                const response = await fiscalCatalogsAPI.searchCfdiUses(filters);
                this.cfdi_uses = response;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
        async searchFiscalRegiments(filters: any) {
            try {
                const response = await fiscalCatalogsAPI.searchFiscalRegiments(filters);
                this.fiscal_regiments = response;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
        async searchProductUnits(filters: any) {
            try {
                const response = await fiscalCatalogsAPI.searchProductUnits(filters);
                this.product_units = response;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
        async searchTaxes(filters: any) {
            try {
                const response = await fiscalCatalogsAPI.searchTaxes(filters);
                this.taxes = response;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
    }
});